import React, {useEffect, useState} from 'react';

const TermsOfUsePage = () => {
    const [termsOfUse, setTermsOfUse] = useState<string | null>(null);

    useEffect(() => {
        fetch('/terms-of-use.html')
            .then((response) => response.text())
            .then((data) => setTermsOfUse(data))
            .catch((error) => console.error('Error fetching privacy policy:', error));
    }, []);

    return (
        <div className="App">
            {termsOfUse ? (
                <div dangerouslySetInnerHTML={{__html: termsOfUse}}/>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
};


export default TermsOfUsePage;